import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import { Layout } from '../components/Layout'

export default function NotFoundPage() {
	React.useEffect(() => {
		if (window.location.href.includes("/sala-do-professor-alfabetizacao")) {
		  window.location.assign("https://sala-professor.novaescola.org.br/sala-do-professor-alfabetizacao")
		}
	  }, [])
	return (
		<Layout
			headerClass="padding-header"
			heroClass="no-hero"
			hasAlert={false}
			setHasAlert={() => {}}
			showAlert={false}
			setShowAlert={() => {}}
		>
			<main role="main" className="container">
				<div className="row">
					<div className="col-md-6 col-sm-12 col-xs-12 d-flex jc-center fd-column">
						<p className="eva-title-3 eva-margin-bottom-4 eva-margin-top-4">Ops! Não encontramos a página que você está procurando</p>
						<p className="eva-margin-bottom-1">Aqui estão alguns links úteis:</p>
						<a href="https://novaescola.org.br/" className="eva-link-azul">Página inicial Nova Escola</a>
						<a href="https://novaescola.zendesk.com/hc/pt-br" className="eva-link-azul">Fale conosco</a>
					</div>
					<div className="col-md-6 col-sm-12 col-xs-12 d-flex jc-center fd-column eva-margin-top-4 eva-margin-bottom-4">
						<StaticImage
              src="https://novaescola.org.br/imagens/erro404.png"
              alt=""
            />
					</div>
				</div>
			</main>
		</Layout>
	)
}
